module.exports = "https://images.shiksha.ws/saassets/media/googlePromptSprite.491d0ca2.svg";